import UnlockedBadge from './UnlockedBadge';

type Props = {
  primaryTitle: string;
  showUnlocked: boolean;
};

// Renders the title text, and when `showUnlocked` is true, keeps the
// last word + the info-icon glued together so the icon never wraps
// onto its own line on narrow viewports.
export default function PrimaryTitleWithBadge({
  primaryTitle,
  showUnlocked,
}: Props) {
  if (!showUnlocked) {
    return <>{primaryTitle}</>;
  }

  const lastSpaceIdx = primaryTitle.lastIndexOf(' ');
  const hasSpace = lastSpaceIdx > 0;
  const mainText = hasSpace ? primaryTitle.slice(0, lastSpaceIdx + 1) : '';
  const lastWord = hasSpace
    ? primaryTitle.slice(lastSpaceIdx + 1)
    : primaryTitle;

  return (
    <>
      {mainText}
      <span className="whitespace-nowrap">
        {lastWord}
        <UnlockedBadge />
      </span>
    </>
  );
}
